import { TSocialMedia } from 'src/models/general';

export const getSocmedFromDomain = (url: string): TSocialMedia => {
  if (url.includes('https://www.facebook.com')) return 'facebook';
  if (url.includes('https://www.instagram.com')) return 'instagram';
  if (
    url.includes('https://www.tiktok.com') ||
    url.includes('https://www.vt.tiktok.com')
  )
    return 'tiktok';
  if (url.includes('https://x.com')) return 'twitter';
  if (url.includes('youtube.com') || url.includes('https://youtu.be'))
    return 'youtube';
  return null;
};
